import { create } from 'zustand';
import { getDefsApi } from '../../../api/api';

const toMap = (items) => Object.fromEntries((items ?? []).map((item) => [item.key, item.name]));

export const useDeviceDefsStore = create((set, get) => ({
  outputsByKey: {},
  subtypesByKey: {},
  statesByType: {},
  isLoading: false,

  fetchDefs: async () => {
    if (get().isLoading || Object.keys(get().outputsByKey).length > 0) return;

    set({ isLoading: true });

    await getDefsApi({
      dataCb: (data) => {
        const statesByType = {};
        const subtypesByKey = {};

        (data?.devices ?? []).forEach((device) => {
          statesByType[device.key] = toMap(device.states);
          (device.subtypes ?? []).forEach((item) => {
            subtypesByKey[item.key] = item.name;
          });
        });

        set({
          outputsByKey: toMap(data?.outputs),
          subtypesByKey,
          statesByType,
          isLoading: false,
        });
      },
      errCb: () => {
        set({ isLoading: false });
      },
    });
  },
}));
